import { Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ListaAccesDepartamente extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <div>
                <Grid container>
                    {this.props.departamente && this.props.departamente.map((d, idx) => {

                        return (
                            <Grid key={idx} item xs={7} sm={7} md={7} lg={7} xl={7}>
                                <Grid style={{
                                    padding: 10,
                                    backgroundColor: '#f1f1f1',
                                    marginBottom: 20
                                }} container>


                                    <Grid style={{ textAlign: 'left' }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                        <span style={{ fontWeight: 700, fontSize: 14 }}>{d.nume}</span><br />

                                    </Grid>




                                    <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <i onClick={() => { this.props.deleteDep(d) }} style={{ fontSize: 20, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} className='material-icons'>delete</i>
                                       
                                    </Grid>
                                </Grid>
                            </Grid>
                        )


                    })}

                </Grid>
            </div>
        );
    }
}